import React, { useMemo } from "react";
import styled from "styled-components";

import ContactUsForm from "../../forms/ContactUsForm";
import PaymentForm from "../../forms/PaymentForm";
import LLCIncForm from "../../forms/LLCIncForm";
import LLCIncFinalizeForm from "../../forms/LLCIncFinalizeForm";
import LLCUpsellForm from "../../forms/LLCUpsellForm";
import TrademarkUpsellForm from "../../forms/TrademarkUpsellForm";
import OrderStatusForm from "../../forms/OrderStatusForm";
import EINSolePropForm from "../../forms/EINSolePropForm";
import EINPartnershipForm from "../../forms/EINPartnershipForm";
import EINCCorpForm from "../../forms/EINCCorpForm";
import EINSCorpForm from "../../forms/EINSCorpForm";
import EINEstateForm from "../../forms/EINEstateForm";
import EINNonProfitForm from "../../forms/EINNonProfitForm";
import EINLLCForm from "../../forms/EINLLCForm";
import EINTrustForm from "../../forms/EINTrustForm";
import EINPSCForm from "../../forms/EINPSCForm";
import EINChurchForm from "../../forms/EINChurchForm";
import BOIUpgradeForm from "../../forms/BOIUpgradeForm";

const StyledFormSection = styled.div`
  display: flex;
  justify-content: center;

  width: 100%;

  .form-container {
    width: 50%;
    padding: 20px;

    &.llc-inc-finalize {
      width: 80%;
    }
  }

  @media ${({ theme }) => theme.devices.laptopM} {
    .form-container {
      width: 60%;

      &.llc-inc-finalize {
        width: 80%;
      }
    }
  }

  @media ${({ theme }) => theme.devices.laptopS} {
    .form-container {
      width: 80%;
    }
  }

  @media ${({ theme }) => theme.devices.tablet} {
    .form-container {
      width: 100%;

      &.llc-inc-finalize {
        width: 100%;
      }
    }
  }
`;

const classes = new Map([
  ["/LLCIncFinalize", "llc-inc-finalize"],
]);

const forms = new Map([
  ["/contactus", ContactUsForm],
  ["/payment", PaymentForm],
  ["/LLCInc", LLCIncForm],
  ["/LLCIncFinalize", LLCIncFinalizeForm],
  ["/LLCUpsell", LLCUpsellForm],
  ["/TrademarkUpsell", TrademarkUpsellForm],
  ["/BOIUpgrade", BOIUpgradeForm],
  ["/status", OrderStatusForm],
  ["/products/EINSoleProp", EINSolePropForm],
  ["/products/EINPartnership", EINPartnershipForm],
  ["/products/EINCCorp", EINCCorpForm],
  ["/products/EINSCorp", EINSCorpForm],
  ["/products/EINEstate", EINEstateForm],
  ["/products/EINNonProfit", EINNonProfitForm],
  ["/products/EINLLC", EINLLCForm],
  ["/products/EINTrust", EINTrustForm],
  ["/products/EINPSC", EINPSCForm],
  ["/products/EINChurch", EINChurchForm],
]);

// eslint-disable-next-line react/display-name
const FormSection = React.forwardRef(({ path, ...restProps }, ref) => {
  const Form = useMemo(() => forms.get(path), [path]);
  const extraClass = useMemo(() => classes.get(path) || "", [path]);

  if (!Form) {
    return null;
  }

  return (
    <StyledFormSection>
      <div className={`form-container ${extraClass}`}>
        <Form ref={ref} {...restProps} />
      </div>
    </StyledFormSection>
  );
});

export default FormSection;
